module.exports = __webpack_public_path__ + "assets/img/weibo.c927c8ae.svg";